export const ID_KEY: unique symbol = Symbol('ID');
export const NAME_KEY: unique symbol = Symbol('Name');
export const TYPE_KEY: unique symbol = Symbol('Type');
export const EVENT_KEY: unique symbol = Symbol('Event Emitter');
export const TITLE_KEY: unique symbol = Symbol('Title');

export const ACTOR_KEY: unique symbol = Symbol('Actor');
export const ROLE_KEY: unique symbol = Symbol('Role');
export const ROLES_KEY: unique symbol = Symbol('Roles');
export const ROLE_NAMES_KEY: unique symbol = Symbol('Role Names');

export const BOUNDARY_KEY: unique symbol = Symbol('Boundary');
export const SUBTYPE_KEY: unique symbol = Symbol('Subtype');
export const STATE_KEY: unique symbol = Symbol('State');

export const GOAL_KEY: unique symbol = Symbol('Goal');
export const GOAL_HANDLER_KEY: unique symbol = Symbol('Goal Handler');

export const HANDLER_KEY: unique symbol = Symbol('Handler');
export const MOCK_HANDLER_KEY: unique symbol = Symbol('Mock Handler');

export const USECASE_KEY: unique symbol = Symbol('Usecase');
export const STORY_KEY: unique symbol = Symbol('Story');

export const TRANSACTION_SESSION: unique symbol = Symbol(
   'Transaction Session',
);
export const TRANSACTION_SIGNATURE: unique symbol = Symbol(
   'Transaction Signature',
);
